import { makeColorSchema } from '../color-utils';
export const violetStyle = makeColorSchema('#2f8af5');
//# sourceMappingURL=violet.style.js.map